import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import './utils/globalLibraries'
import '@mdi/font/css/materialdesignicons.css'
import './assets/css/visit-flow.css'
import ApiServiceLayer from '@/api/apiServiceLayer';
import router from './router'
import Store from './store/index';

import vuetify from './plugins/vuetify'
const Path = require('./utils/applicationPath');

Vue.prototype.$ApiServiceLayer = new ApiServiceLayer();
Vue.prototype.$PATH = Path;
Vue.prototype.$STORE = Store;

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
